import {ResourceTypeEnum} from "../base/training-literals";
import {AnimationResource} from "./animation";

class ResourceAuthoringController {
    constructor() {
        this.currentResource = null;

        wv.communicator.addEventListener(text_setCurrentAuthoringResource, async (itemArr) => {
            const type = itemArr[0];

            await this.currentResource?.cancel();
            this.currentResource = this.createResourceFromType(type);
        });
    }

    createResourceFromType(type) {
        switch (type) {
            case ResourceTypeEnum.ANIMATION:
                return new AnimationResource();
            default:
                return null;
        }
    }
}

export default new ResourceAuthoringController();
